export const FAQs = [
  {
    id: 1,
    question: "How does the platform help with case research?",
    answer:
      "Our platform uses AI-powered tools to analyze vast amounts of legal data, providing relevant case law, statutes, and regulations to support your research.",
  },
  {
    id: 2,
    question: "What is the purpose of this Legal AI platform?",
    answer:
      "This platform is designed to assist legal professionals in researching, analyzing, and resolving cases more efficiently and effectively.",
  },
  {
    id: 3,
    question: "Can I use this platform for all types of legal cases?",
    answer:
      "Our platform is designed to support a wide range of legal cases, including civil, criminal, family, and corporate law. However, please note that the platform is not a substitute for professional legal advice.",
  },
  {
    id: 4,
    question: "How accurate is the information provided by the platform?",
    answer:
      "Our platform uses advanced AI algorithms to analyze and provide accurate and up-to-date legal information. However, it's always best to verify information through additional research and consultation with legal experts.",
  },
  {
    id: 5,
    question: "Can I collaborate with colleagues and clients on this platform?",
    answer:
      "Yes, our platform allows you to invite colleagues and clients to collaborate on cases, share documents, and communicate securely.",
  },
  {
    id: 6,
    question: "Is my case data secure on this platform?",
    answer:
      "Yes, our platform uses robust security measures, including encryption and secure servers, to protect your case data and ensure confidentiality.",
  },
  {
    id: 7,
    question: "What kind of support does the platform offer?",
    answer:
      "Our platform offers comprehensive support, including online tutorials, customer support, and regular updates to ensure you get the most out of our tools and features. ",
  },
];

export const swiperData = [
  {
    title: "Sign Up & Set Up",
    para: "Quickly create your account and customize your profile to fit your court's needs",
  },
  {
    title: "Upload Documents",
    para: "Seamlessly upload case files and documents, organizing everything in one place.",
  },
  {
    title: "Advanced Search",
    para: "Use our powerful search engine to find relevant cases and references with ease.",
  },
  {
    title: "Speech-to-Text & Live Captions",
    para: "Dictate notes and receive real-time captions during proceedings for accurate documentation.",
  },
  {
    title: "AI-Driven Insights",
    para: "Receive intelligent suggestions and case analysis tailored to your needs.",
  },
];
